// extracted by mini-css-extract-plugin
module.exports = {"myOptinsFormCard":"MyOptinsFormCard_myOptinsFormCard__6_b5J","rotation":"MyOptinsFormCard_rotation__20ShU"};